// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@conklin/MobiusOverrides/TextField/TextField";
import { customerAddressFormFieldStyles } from "@conklin/Overrides/Components/CustomerAddressFormFields";
import translate from "@insite/client-framework/Translate";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

customerAddressFormFieldStyles.container = {
    gap: 20,
    css: css`
        ${GridItemStyle} {
            padding-top: 6px;
            padding-bottom: 6px;
        }
    `,
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("First Name"),
    type: "firstName",
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Last Name"),
    type: "lastName",
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Company Name"),
    type: "comapnyName",
} as TextFieldProps;

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Address1"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Address2"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Address3"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Address4"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("City"),
    type: "city",
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Postal Code"),
    type: "postalCode",
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("Phone"),
    type: "phone",
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("Fax"),
} as TextFieldProps;

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Email"),
    type: "email",
} as TextFieldProps;

customerAddressFormFieldStyles.cityGridItem =
    customerAddressFormFieldStyles.countryGridItem =
    customerAddressFormFieldStyles.emailGridItem =
    customerAddressFormFieldStyles.phoneGridItem =
    customerAddressFormFieldStyles.companyNameGridItem =
    customerAddressFormFieldStyles.attentionGridItem =
    customerAddressFormFieldStyles.firstNameGridItem =
    customerAddressFormFieldStyles.lastNameGridItem =
        {
            width: [12, 12, 6, 6, 6],
        };

customerAddressFormFieldStyles.postalCodeGridItem = customerAddressFormFieldStyles.stateGridItem = {
    width: [12, 12, 3, 3, 3],
};

customerAddressFormFieldStyles.taxExemptGridItem = {
    width: 12,
    css: css`
        align-items: center;
        justify-content: space-between;
    `,
};

customerAddressFormFieldStyles.taxExempt = {
    css: css`
        width: 100%;
        margin-top: 16px;
    `,
};

customerAddressFormFieldStyles.taxExmptionCertificateField = {
    cssOverrides: {
        formField: css`
            padding-left: 10px;
        `,
    },
};

customerAddressFormFieldStyles.taxExmptionWrapper = {
    css: css`
        width: 100%;
        ${({ taxExempt }: any) => (!taxExempt ? "display: none" : "display: inline-flex")};
    `,
};
